export const moveItemToShoppingBag = (id, item, attribute) => {
	var ajaxUrl = '/webapp/wcs/stores/servlet/InterestItemDelete?';

	ajaxUrl +=
		'catEntryId=' +
		item +
		'&storeId=301&catalogId=301&langId=-1&calculationUsageId=-1&calculationUsageId=-2&updatePrices=1&quantity=1&errorViewName=InterestItemDisplayView';
	ajaxUrl +=
		'&URL=OrderItemAdd%3FURL%3DOrderCalculate%3FURL%3DOrderItemDisplay%26location%3DMyDillards%26cm_vc%3Dwishlist%26myDillardsBar%3Dtrue%26catEntryId%3D' +
		item +
		'&field2=' +
		attribute;

	$.ajax({
		type: 'POST',
		url: ajaxUrl,
		dataType: 'json',
		success: function (data, textStatus) {
			$('#' + id).remove();
			if ($('.wish-list-table tbody').children().length <= 0)
				$('#myDillardsDropdownDynamic').html('<p class="m-top">Your wish list currently does not contain any items.</p>');
			return false;
		},
		error: function (jqXHR, textStatus, errorThrown) {
			var ajaxUrl2 = '/webapp/wcs/stores/servlet/InterestItemDelete?';

			ajaxUrl2 +=
				'catEntryId=' +
				item +
				'&storeId=301&catalogId=301&langId=-1&calculationUsageId=-1&calculationUsageId=-2&updatePrices=1&quantity=1&errorViewName=InterestItemDisplayView';
			ajaxUrl2 += '&URL=OrderItemAdd%3FURL%3DOrderCalculate%3FURL%3DOrderItemDisplay%26cm_vc%3Dwishlist%26catEntryId%3D' + item;
			window.parent.location = ajaxUrl2;

			return false;
		},
	});
};
